import React from 'react';

import {MdTextField} from 'core/components/fields/fields';
import Form, {FIELDDEFDISPLAYTYPE} from 'core/form/form';
import {createForm} from 'core/form/createForm';
import {FormProps, lovValue} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {Validate} from 'core/form/validate';
import {Min, NumberFormat} from 'core/form/rules';
import {optionsSearch} from "core/common/service/commonDataService";
import {action, observable} from "mobx";
import {observer} from "mobx-react";
import {ADDRESSPLACETYPE, Party, PARTYROLE} from "party/partyDomain";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import {Shipment, SHIPMENTSTATUS_COLORS, ShipmentVisit} from "shipment/shipmentDomain";
import {grey400} from "material-ui/styles/colors";
import RadioButtonField from "core/components/fields/radioButtonField";
import {LovItem} from "core/metamodel/mdEntity";
import securityService from "core/security/securityService";
import {ShipmentVisitClosedContent} from "shipment/component/shipmentVisitDriverForm";
import mdEntityService from "core/metamodel/mdEntityService";
import shipmentService from "shipment/shipmentService";
import {loc} from "core/common/config/locales";
import productService from "product/productService";
import {Vehicle} from "product/productDomain";
import {ShipmentRequestedTime} from "shipment/component/shipmentRequestedTime";


@createForm({
  formName: 'ShipmentIncomingForm',
  fields: [{
    name: 'shipmentDate',
    validators: ['IsRequired']
  }, {
    name: 'shipmentStatus',
    validators: ['IsRequired'],
    displayType: FIELDDEFDISPLAYTYPE.radioButton
  },  {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'shippedFrom',
    validators: ['IsRequired']
  }, {
    name: 'registrationNumber'
  }, {
    name: 'driverPhone'
  }, {
    name: 'shippedToPlace'
  }, {
    name: 'gateArrivalTime'
  }, {
    name: 'vendorArrivalTime'
  }, {
    name: 'endOfLoadingTime'
  }, {
    name: 'plannedPaletteCount',
    validators: ['IsNumber']
  }, {
    name: 'unloadedPaletteCount',
    validators: ['IsNumber']
  }, {
    name: 'notUnloadedPaletteCount',
    validators: ['IsNumber'],
  }, {
    name: 'unloadingNumber'
  }, {
    name: 'loadingTruckCount',
    validators: ['IsNumber']
  }, {
    name: 'unloadingTruckCount',
    validators: ['IsNumber']
  }, {
    name: 'gateLoadingDuration'
  }, {
    name: 'vendorLoadingDuration'
  }, {
    name: 'shipmentVisit'
  }, {
    name: 'maxWaitingTime'
  }, {
    name: 'hauler'
  }, {
    name: 'vehicle'
  }, {
    name: 'visitOrder',
    validators: ['IsNumber', 'IsRequired']
  }]
}, () => <noscript/> )
@observer
export default class ShipmentIncomingForm extends React.Component<FormProps<Shipment, Shipment>> {


  componentDidMount() {
    let {dataObject, form} = this.props;
    return this.populateDropdowns(form, dataObject);
  }

  componentDidUpdate(prevProps: FormProps<Shipment, Shipment>) {
    let {dataObject, form} = this.props;

    if (prevProps.dataObject.shipmentId !== dataObject.shipmentId) { // kvuli copy nebo horizontalnimu posunu
      console.debug("componentDidUpdate - populateDropdowns");
      return this.populateDropdowns(form, dataObject);
    }
  }



  private populateDropdowns(form: Form<Shipment>, dataObject: Shipment) {
    return optionsSearch('AddressPlace', {
      partyId: securityService.currentTenant.party.value,
      placeType: ADDRESSPLACETYPE.INCOMING
    }).then(action("onShippedToChange-cb1", ({options: placeOptions}: { options: LovItem[] }) => {
      placeOptions.unshift({value: null, label: '---'});
      form.getField("shippedToPlace").props.options = observable.shallowArray(placeOptions);
      form.updateFieldsPropValue(dataObject, "shippedToPlace");
    }));
  }


  render() {


    let {dataObject, rootObject, entity, entities, form, formName} = this.props;
    let fields = form.fields;
    let {
      shipmentDate, shipmentStatus, comment, shippedFrom, registrationNumber,  shippedToPlace,
      plannedPaletteCount, unloadedPaletteCount, notUnloadedPaletteCount, unloadingNumber, loadingTruckCount, unloadingTruckCount,
      shipmentVisit, maxWaitingTime, hauler, vehicle, visitOrder
    } = dataObject.getFormFields(formName);

    const shipmentVisitEntity = mdEntityService.entityMap.get('ShipmentVisit');

    console.debug("dataObject.$shipmentVisit ", dataObject.$shipmentVisit);

    return (

      <form style={{marginTop: 10}}>
        <BlockComp>
          <div className="row">
            <div className="fx col-xs-3">
              <StyledDatePicker {...shipmentDate.props}  />
              <Validate field={shipmentDate} value={shipmentDate.props.value}/>
            </div>
            <div className="col-xs-8 col-xs-offset-1">
              <div style={{color: grey400, marginBottom: 5}}>{shipmentStatus.mdField.formLabelActive}</div>
              <RadioButtonField {...shipmentStatus.props} groupStyle={{display: 'flex'}}
                                optionStyle={{width: 'initial', marginRight: 15}}
                                labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}
                                iconStyleFn={v => ({fill: SHIPMENTSTATUS_COLORS[v]})}/>
              <Validate field={shipmentStatus} value={shipmentStatus.props.value}/>
            </div>
          </div>
        </BlockComp>


        <div className="row">
          <div className="col-xs-12 col-sm-6">

            <BlockComp className="block-comp-right-border" header={loc.i18n`Supplier`} style={{marginBottom: 0}}>
              <div className="row">
                <div className="fx col-xs-12">
                  <StyledSelect  {...shippedFrom.props} async={true}
                                 loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.SUPPLIER_ROLE]})}
                                 clearable={true}/>
                  <Validate field={shippedFrom} value={shippedFrom.props.value} onSuccess={this.onShippedFromSuccess}/>
                </div>
              </div>
              <div className="row">
                <div className="fx col-xs-12">
                  <StyledSelect  {...hauler.props} async={true} asterixForAll
                                 loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.HAULER]})}
                                 clearable={true} />
                  <Validate field={hauler} value={hauler.props.value} onSuccess={this.onHaulerSuccess}/>
                </div>
              </div>
              <div className="row">
                <div className="fx col-xs-12">
                  <StyledSelect {...shippedToPlace.props} floatingLabelText={loc.i18n`Unloading place`} clearable={false} />
                </div>
              </div>
            </BlockComp>

            <BlockComp className="block-comp-right-border" header={loc.i18n`Car`} style={{marginBottom: 0}}>
              <div className="row">
                <div className="fx col-xs-6">
                  <StyledSelect {...vehicle.props}  asterixForAll
                                async={true} loadOptions={optionsSearch.bind(this, 'Vehicle', {partyId: dataObject.hauler ? lovValue(dataObject.hauler) : -1})} />
                  <Validate field={vehicle} value={vehicle.props.value} onSuccess={this.onVehicleSuccess}/>
                </div>
                <div className="fx col-xs-6">
                  <MdTextField {...registrationNumber.props} />
                </div>
              </div>
            </BlockComp>

          </div>


          <div className="col-xs-12 col-sm-6">

            <BlockComp header={loc.i18n`Unloading`} style={{marginBottom: 0}}>


              <div className="row">
                <div className="fx col-xs-6">
                  <NumberField {...plannedPaletteCount.props} />
                  <Validate field={plannedPaletteCount} value={plannedPaletteCount.props.value} onSuccess={this.shipmentDetailsFilled}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-6">
                  <NumberField {...unloadedPaletteCount.props} />
                  <Validate field={unloadedPaletteCount} value={unloadedPaletteCount.props.value} onSuccess={this.shipmentDetailsFilled}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-6">
                  <NumberField {...notUnloadedPaletteCount.props} />
                  <Validate field={notUnloadedPaletteCount} value={notUnloadedPaletteCount.props.value}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-6">
                  <MdTextField {...unloadingNumber.props} />
                </div>
              </div>

              <div className="row">
                <div className="fx col-xs-6">
                  <NumberField {...loadingTruckCount.props} />
                  <Validate field={loadingTruckCount} value={loadingTruckCount.props.value}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-6">
                  <NumberField {...unloadingTruckCount.props} />
                  <Validate field={loadingTruckCount} value={unloadingTruckCount.props.value}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
              </div>

              <div className="row">
                <div className="fx col-xs-3">
                  <NumberField {...maxWaitingTime.props} />
                  <Validate field={maxWaitingTime} value={maxWaitingTime.props.value}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-3">
                  <NumberField {...visitOrder.props} />
                  <Validate field={visitOrder} value={visitOrder.props.value}>
                    <NumberFormat precision={2} scale={0}/>
                    <Min min={1}/>
                  </Validate>
                </div>
                <div className="col-xs-6">
                  <div style={{color: grey400, marginBottom: 5}}>{loc.i18n`Requested unloading time`}</div>
                  <ShipmentRequestedTime timeStart={dataObject.requestedUnloadingStart} timeEnd={dataObject.requestedUnloadingEnd} changeTimeFn={this.onChangeTime} dialogTitle={loc.i18n`Requested unloading time`}/>
                </div>
              </div>
            </BlockComp>

            <BlockComp style={{marginBottom: 0, paddingBottom: 0}}>
              <div className="row">
                <div className="fx col-xs-12">
                  <StyledSelect  {...shipmentVisit.props} async={true}
                                 loadOptions={optionsSearch.bind(this, 'ShipmentVisit', {unassigned: true})}
                                 clearable={true} asterixForAll/>
                  <Validate field={shipmentVisit} value={shipmentVisit.props.value} onSuccess={this.onShipmentVisitSuccess}/>
                </div>
              </div>
              {(dataObject.$shipmentVisit) ? <ShipmentVisitClosedContent dataObject={dataObject.$shipmentVisit} entities={entities} entity={shipmentVisitEntity}
                                                                  fields={new Form("ShipmentVisitDriverForm", mdEntityService.getFormDefinition("ShipmentVisitDriverForm")).setupFields(dataObject.$shipmentVisit, dataObject.$shipmentVisit, shipmentVisitEntity, entities, null)}/> : null}
            </BlockComp>



          </div>

        </div>


        <div className="row">
          <div className="col-xs-12">
            <BlockComp style={{marginBottom: 0, marginTop: 0}}>

              <div className="row">
                <div className="fx col-xs-12">
                  <MdTextField {...comment.props} multiLine={true} rows={3}/>
                </div>
              </div>

            </BlockComp>
          </div>
        </div>


      </form>

    )
  }

  @action onChangeTime = (timeStart, timeEnd) => {
    console.log("onChangeTime: timeStart " + timeStart + ", timeEnd " + timeEnd);
    let {dataObject, rootObject} = this.props;
    dataObject.requestedUnloadingStart = timeStart;
    dataObject.requestedUnloadingEnd = timeEnd;
    rootObject.$dirty = true;
  }

  @action shipmentDetailsFilled = () => {
    let {dataObject, form} = this.props;
    let result = dataObject.plannedPaletteCount - dataObject.unloadedPaletteCount;
    if(!(dataObject.unloadedPaletteCount == null)) {
      console.log(dataObject.plannedPaletteCount - dataObject.unloadedPaletteCount)

      form.getField("notUnloadedPaletteCount").props.value = result;
      dataObject.notUnloadedPaletteCount = result;
      form.updateFieldsPropValue(dataObject, "notUnloadedPaletteCount");

      if(result < 0) {
      form.getField("notUnloadedPaletteCount").props.value = 0;
      dataObject.notUnloadedPaletteCount = 0;
      form.updateFieldsPropValue(dataObject, "notUnloadedPaletteCount");
      }
    }
  }

  @action onShippedFromSuccess = () => {
    let {entities, dataObject, form} = this.props;
    console.log('onShippedFromSuccess ', dataObject.shippedFrom);

    let partyId = lovValue(dataObject.shippedFrom);

    return   ( (partyId != null) ? Promise.all([shipmentService.computeField("shippedToPlace", {shippedFrom: lovValue(dataObject.shippedFrom)}),
      shipmentService.computeField("hauler", {partyId})]) : Promise.all([Promise.resolve(null), Promise.resolve(null)]) )
      .then(action("onShippedToChange-cb1", ([shippedToPlaceValue, haulerLov]: [number, LovItem]) => {

        let fieldsToUpdate: string[] = [];

        if (shippedToPlaceValue) {
          dataObject.shippedToPlace =  form.getField("shippedToPlace").props.options.find(lov => lov.value === shippedToPlaceValue)
          fieldsToUpdate.push("shippedToPlace");
        }

        if (haulerLov) {
          dataObject.hauler = haulerLov;
          fieldsToUpdate.push("hauler");
        }

        form.updateFieldsPropValue(dataObject, ...fieldsToUpdate);

      }));
  };

  @action onShipmentVisitSuccess = () => {
    let {dataObject, form} = this.props;
    console.log("onShipmentVisitSuccess");
    let visitPromise = (dataObject.shipmentVisit) ? shipmentService.readShipmentVisit(lovValue(dataObject.shipmentVisit)) : Promise.resolve(null);
    visitPromise.then( (visit) => {
      dataObject.$shipmentVisit = visit;
      if (!dataObject.registrationNumber && !!visit) {
        dataObject.registrationNumber = visit.registrationNumber;
        form.updateFieldsPropValue(dataObject, "registrationNumber");
      }
    });
  };

  @action onHaulerSuccess = () => {
    let {dataObject, form} = this.props;
    dataObject.vehicle = undefined;
    form.updateFieldsPropValue(dataObject, "vehicle");
  }

  @action onVehicleSuccess = () => {
    let {dataObject, form} = this.props;
    if (dataObject.vehicle) {
      productService.readVehicle(lovValue(dataObject.vehicle))
        .then(action("onVehicleSuccessA", (vehicle: Vehicle) => {
          dataObject.registrationNumber = vehicle.registrationNumber;
          form.updateFieldsPropValue(dataObject, "registrationNumber");
        }));
    }
  }



}






// WEBPACK FOOTER //
// ./src/shipment/component/shipmentIncomingForm.tsx